export const CONNECT_WALLET="Connect Wallet";
export const SEARCHCOLLECTIONSANDCREATORS="Search Collections and Creators";
export const THEWITCHERWILDHUNT="THE WITCHER 3: WILD HUNT";
export const HOW="HOW";
export const ITWORKS=" IT WORKS";
export const CROSSCHAINPLATFORM=" #1 Cross-chain platform";
export const FEATURED="FEATURED";
export const GAMES="GAMES";
export const VIEWALL="View All";
export const UPCOMMING="UPCOMMING";
export const PROJECTS="PROJECTS";
export const BACKED="BACKED";
export const BY="BY";
export const BACKEDBYCONTENT1="SolaDefy is honoured and thrilled to be";
export const BACKEDBYCONTENT2="backed by leading Venture Capitals";
export const BACKEDBYCONTENT3="in blockchain industry.";
export const HOMEFOOTERCONTENT="Defy the odds & launch with soladefy";
export const APPLYNOW="Apply Now";
export const BUILDYOUROWNVIKINGLEGEND="BUILD YOUR OWN VIKING LEGEND";


 